import { useTranslations } from 'next-intl';

import { Link, usePathname } from '@/i18n/navigation';
import { cn } from '@/lib/utils/cn';
import { getPoolsLinkHref } from '@/lib/utils/pools';
import { useGlobalData } from '@/providers/GlobalDataProvider';
import { C_Routes } from '@/ts/constants/C_Routes';
import { E_Routes } from '@/ts/enums/E_Routes';

interface I_NavigationProps {
  className?: string;
  firstPoolSlug?: string | null;
  isNotFound?: boolean;
}

export function Navigation({ className = '' }: I_NavigationProps) {
  const pathname = usePathname();

  const t = useTranslations();
  const tCommon = useTranslations('common');

  const pools = useGlobalData('pools');

  const poolsLink = getPoolsLinkHref(pools, {
    fallbackPresaleHref:
      C_Routes[E_Routes.POOLS_PRESALE]?.link || '/pools-presale'
  });

  const navItems = [
    {
      href: `${C_Routes[E_Routes.HOME].link}`,
      label: tCommon('home'),
      isActive: pathname === '/'
    },
    {
      href: poolsLink,
      label: t('navigation.pools'),
      isActive: pathname.startsWith('/pools')
    }
  ];

  return (
    <nav className={cn('flex items-center gap-5', className)}>
      {navItems.map(item => (
        <Link
          key={item.href}
          href={item.href}
          className={cn(
            'text-base font-normal transition-colors hover:text-primary p-2 text-center',
            item.isActive
              ? 'text-base text-primary border-b-2 border-primary-border font-bold '
              : 'text-muted-foreground '
          )}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
}
